var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "", header: _vm.header } },
        [
          _c("b-card-body", [
            _c("p", [_vm._v(_vm._s(_vm.$t("admin.experimental_info")))]),
          ]),
          _c(
            "b-card-footer",
            [
              _c(
                "b-button",
                {
                  staticClass: "px-4",
                  attrs: { variant: "outline-primary", disabled: "" },
                  on: { click: _vm.saveChanges },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.update")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }